import React from 'react'

import { Col, Row, Button, Divider } from '_zari/core'

import * as FormGroups from './formGroups'
import * as Sections from './sections'

const CODIGOS_SECCIONES = {
  REPORTE: 'REP',
  ESQUEMA: 'ESQ',
  ASIGNACION: 'ASI'
}

const BalanceGeneralPage = () => {
  const [codigoActivo, setCodigoActivo] = React.useState(CODIGOS_SECCIONES.REPORTE)
  const [mostrarComplementos, setMostrarComplementos] = React.useState(false)

  const clickCambioSeccion = React.useCallback(nuevo => {
    setCodigoActivo(nuevo)
  }, [])

  return (
    <Row>
      <Col md={2}>
        <Row className='mb-2'>
          <Col md={12}>
            <Button
              block
              tiny
              outline={codigoActivo !== CODIGOS_SECCIONES.REPORTE}
              onClick={() => clickCambioSeccion(CODIGOS_SECCIONES.REPORTE)}
            >
              Reporte
            </Button>
          </Col>
        </Row>
        <Divider />
        <Row className='zari-slim-form'>
          <Col md={12}>
            <FormGroups.FlagMostrarComplementosFormGroup
              iValue={mostrarComplementos}
              onClick={() => setMostrarComplementos(prev => !prev)}
            />
          </Col>
        </Row>
        {mostrarComplementos && (
          <>
            <Row>
              <Col md={12}>
                <Button
                  color='warning'
                  block
                  tiny
                  outline={codigoActivo !== CODIGOS_SECCIONES.ASIGNACION}
                  onClick={() => clickCambioSeccion(CODIGOS_SECCIONES.ASIGNACION)}
                >
                  Asignación de Enlaces
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Button
                  color='warning'
                  block
                  tiny
                  outline={codigoActivo !== CODIGOS_SECCIONES.ESQUEMA}
                  onClick={() => clickCambioSeccion(CODIGOS_SECCIONES.ESQUEMA)}
                >
                  Esquema de Balance
                </Button>
              </Col>
            </Row>
          </>
        )}
      </Col>
      <Col md={10}>
        {codigoActivo === CODIGOS_SECCIONES.REPORTE && <Sections.ReporteSection />}
        {codigoActivo === CODIGOS_SECCIONES.ASIGNACION && <Sections.AsignacionEnlaceSection />}
        {codigoActivo === CODIGOS_SECCIONES.ESQUEMA && <Sections.EsquemaSection />}
      </Col>
    </Row>
  )
}

export default React.memo(BalanceGeneralPage)
